module.exports = __webpack_public_path__ + "img/telephone-icon.8d0b9442.svg";